angular.module('PinMeTo.directives').directive('pmtAutoFocus', [
	'$timeout',
	function ($timeout) {
		'use strict';

		return {
			restrict: 'A',
			link: function (_scope, _element) {
				$timeout(function () {
					_element[0].focus();
				}, 350);
			}
		};
	}
]);
